import { useCallback, useEffect, useState } from "react";
import { ShopAuditRow } from "@/hooks/queries/useShopConfigAuditRows";

// Selection is held by shop id (not row object) so it survives refetches. The
// first row auto-selects so the pane is populated on load, but a pane the user
// closed must not reopen itself when the rows change.
export const useAuditSelection = (rows: ShopAuditRow[]) => {
  const [selectedShopId, setSelectedShopId] = useState<string | null>(null);
  const [closedByUser, setClosedByUser] = useState(false);

  const selectedRow = rows.find((r) => r.shop.id === selectedShopId) ?? null;

  useEffect(() => {
    if (!closedByUser && !selectedRow && rows.length > 0) {
      setSelectedShopId(rows[0].shop.id);
    }
  }, [closedByUser, selectedRow, rows]);

  const select = useCallback((row: ShopAuditRow) => {
    setSelectedShopId(row.shop.id);
    setClosedByUser(false);
  }, []);

  const close = useCallback(() => {
    setSelectedShopId(null);
    setClosedByUser(true);
  }, []);

  return { selectedRow, select, close };
};
